import ValidService from "../../../../service/ValidService";

let model = {};

// dữ liệu form
model.dataForm = {
    "id": undefined, // optional Mã tự sinh
    "employee_id": undefined, // required Id nhân viên
    "employee_no": undefined, // required Mã nhân viên
    "company_id": undefined, // required Mã công ty
    "company_name": undefined, // optional Tên công ty
    "salary_period_id": undefined, // required Kỳ lương Id
    "salary_period_name": undefined, // required Tên kỳ lương
    "custom_fields": [ // optional Các field được cấu hình động
    {
        "key": undefined, // required Tên cột
        "value": undefined, // required Giá trị
        "user_input": undefined, // required Tự động hay người dùng nhập
    }], 
    "total_income": undefined, // required Tổng thu nhập
    "sealed": undefined, // required Đã chốt chưa
    "sealed_at": undefined, // optional Thời điểm chốt
    "created_at": undefined, // required Thời điểm tạo
    "updated_at": undefined, // required Thời điểm cập nhật
    "disabled": undefined, // required Đã bị khóa chưa
}

// validation form
model.validForm = {};

// dữ liệu mẫu các form khác
model.dataFormOther = {};

// validation các form khác
model.validFormOther = {};


model.tableRules = {
    data: [],
    lengthMenu: [10, 20, 50, 100],
    allowPaging: true,
    allowSorting: true,
    allowSelect: false,
    showFormSearch: false,
    showUrl: true,
    total: 0,
    page: 1,
    limit: 10,
    offset: 0,
    sort: "",
    defaultSort: ["", "ascending"],
    filters: "",
    recordSelected: [],
    dataSearch: {
        value: {},
        valid: {},
        operator: {}
    }
};

export default model;